import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ItemCategoryName({itemCategory, clickable, ...props}) {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      gap={1}
      onClick={() => clickable && navigate(`/item_categories/${itemCategory.id}`)}
      px={0.5}
      borderRadius={"3px"}
      sx={{
        cursor: clickable && "pointer",
        "&:hover": {
          bgcolor: clickable && "rgba(0, 0, 0, 0.04)"
        }
      }}
    >
      <Box my="auto" bgcolor={itemCategory?.tag_color} borderRadius="100px" width="10px" maxHeight="10px" height="10px" />
      <Typography sx={{ my: 'auto' }} {...props}>
        {itemCategory?.name}
      </Typography>
    </Stack>
  );
}